import { all, takeLatest, put, call } from 'redux-saga/effects';
import leaveService from '../../services/leave';
import { leaveActionTypes } from './Leave.actionTypes';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';

/**
 * Get leave requests assigned to the manager (assignee)
 */
export function* getManagerRequestsSaga({ payload }) {
  try {
    yield put({
      type: leaveActionTypes.SET_STATE,
      payload: { loading: true },
    });

    const { managerId, companyId } = payload;
    const managerRequests = yield call(
      leaveService.getManagerRequests,
      companyId,
      managerId
    );

    yield put({
      type: leaveActionTypes.SET_STATE,
      payload: {
        managerRequests,
        loading: false,
        error: null,
      },
    });
  } catch (error) {
    console.error('Error fetching leave manager requests:', error);
    yield put({
      type: leaveActionTypes.SET_STATE,
      payload: {
        managerRequests: [],
        loading: false,
        error: error.message,
      },
    });
    addNotification({
      message: 'Failed to load leave requests',
      level: notificationStates.error,
    });
  }
}

/**
 * Approve a leave request: update status and write leave to attendance
 */
export function* approveRequestSaga({ payload }) {
  try {
    yield put({
      type: leaveActionTypes.SET_STATE,
      payload: { approveLoading: true },
    });

    const { companyId, requestId, requestData } = payload;
    yield call(
      leaveService.approveLeaveRequest,
      companyId,
      requestId,
      requestData
    );

    addNotification({
      message: 'Leave request approved successfully',
      level: notificationStates.success,
    });

    yield put({
      type: leaveActionTypes.SET_STATE,
      payload: { approveLoading: false },
    });

    yield put({
      type: leaveActionTypes.GET_MANAGER_REQUESTS,
      payload: {
        managerId: requestData.assignee,
        companyId,
      },
    });
  } catch (error) {
    console.error('Error approving leave request:', error);
    yield put({
      type: leaveActionTypes.SET_STATE,
      payload: { approveLoading: false },
    });
    addNotification({
      message: error.message || 'Failed to approve leave request',
      level: notificationStates.error,
    });
  }
}

/**
 * Reject a leave request: only update status to Rejected
 */
export function* rejectRequestSaga({ payload }) {
  try {
    yield put({
      type: leaveActionTypes.SET_STATE,
      payload: { rejectLoading: true },
    });

    const { companyId, requestId, assigneeId } = payload;
    yield call(leaveService.rejectLeaveRequest, companyId, requestId);

    addNotification({
      message: 'Leave request rejected successfully',
      level: notificationStates.success,
    });

    yield put({
      type: leaveActionTypes.SET_STATE,
      payload: { rejectLoading: false },
    });

    yield put({
      type: leaveActionTypes.GET_MANAGER_REQUESTS,
      payload: {
        managerId: assigneeId,
        companyId,
      },
    });
  } catch (error) {
    console.error('Error rejecting leave request:', error);
    yield put({
      type: leaveActionTypes.SET_STATE,
      payload: { rejectLoading: false },
    });
    addNotification({
      message: error.message || 'Failed to reject leave request',
      level: notificationStates.error,
    });
  }
}

export default function* leaveWatcher() {
  yield all([
    takeLatest(leaveActionTypes.GET_MANAGER_REQUESTS, getManagerRequestsSaga),
    takeLatest(leaveActionTypes.APPROVE_REQUEST, approveRequestSaga),
    takeLatest(leaveActionTypes.REJECT_REQUEST, rejectRequestSaga),
  ]);
}
